import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

function Header() {
  const location = useLocation();
  const navigate = useNavigate();

  const handleHomeClick = (e) => {
    if (location.pathname === "/") {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleScrollLink = (e, id) => {
    if (location.pathname === "/") return;
    e.preventDefault();
    navigate(`/#${id}`);
  };

  return (
    <>
      <header
        className="header"
        style={{
          position: "fixed",
          width: "100%",
          top: 0,
          zIndex: 1000,
        }}
      >
        <h2
          className="logo"
          onClick={() => {
            navigate("/");
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          style={{ cursor: "pointer" }}
        >
          Ramcharan Constructions
        </h2>

        <nav>
          <ul
            className="nav-links"
            style={{
              display: "flex",
              listStyle: "none",
              gap: "20px",
              alignItems: "center",
            }}
          >
            <li>
              <Link to="/" onClick={handleHomeClick}>
                Home
              </Link>
            </li>

            <li>
              <a href="#about" onClick={(e) => handleScrollLink(e, "about")}>
                About Us
              </a>
            </li>

            <li>
              <a href="#projects" onClick={(e) => handleScrollLink(e, "projects")}>
                Projects
              </a>
            </li>

            <li>
              <a href="#career" onClick={(e) => handleScrollLink(e, "career")}>
                Careers
              </a>
            </li>
          </ul>
        </nav>
      </header>

      <div style={{ height: "70px" }} />
    </>
  );
}

export default Header;